import React from "react";
import { Navigate } from "react-router-dom";

const ONBOARDING_DONE_KEY = "leadzlab_onboarding_done";

/**
 * /onboarding redirects straight to the wizard—no extra welcome screen.
 * New users land on "What do you want to find?" immediately.
 */
export default function OnboardingWelcome() {
  return <Navigate to="/onboarding/create-matcher" replace />;
}

export { ONBOARDING_DONE_KEY };
